import { GtmTracking } from './GtmTracking';
import * as Types from './events';
import { TrackConfig } from './types';

const gtm = new GtmTracking();

export type { GroupEvent, Session } from './events';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Gtm {
  export const Group = Types.GroupName;
  export const StandaloneEvent = Types.StandaloneEventName;
  export const ProductEvent = Types.ProductEventName;
  export const ComponentEvent = Types.ComponentEventName;
  export const CommonEvent = Types.CommonEventName;
  export const CartEvent = Types.CartEventName;
  export const CollectionEvent = Types.CollectionEventName;
  export const CheckoutEvent = Types.CheckoutEventName;
  export const CheckoutExpressEvent = Types.CheckoutExpressEventName;
  export const CheckoutWalletEvent = Types.CheckoutWalletEventName;
  export const CheckoutQuestionnaireEvent = Types.CheckoutQuestionnaireEventName;
  export const FuBeEvent = Types.FuBeEventName;
  export const AccountEvent = Types.AccountEventName;
  export const LoyaltyEvent = Types.LoyaltyEventName;
  export const SubscriptionEvent = Types.SubscriptionEventName;
  export const PromoBarEvent = Types.PromoBarEventName;
  export const PickyCatsEvent = Types.PickyCatsEventName;
  export const ConsentEvent = Types.ConsentEventName;
  export const StoryEvent = Types.StoryEventName;

  export const PaymentGateway = Types.PaymentGateway;

  /* eslint-disable prettier/prettier */
  export const track = Object.assign(gtm.track.bind(gtm), {
    selectElement: createStandaloneEventTrack(StandaloneEvent.SelectElement),
    unselectElement: createStandaloneEventTrack(StandaloneEvent.UnselectElement),
    scrollElement: createStandaloneEventTrack(StandaloneEvent.ScrollElement),
    viewElement: createStandaloneEventTrack(StandaloneEvent.ViewElement),
    zoomElement: createStandaloneEventTrack(StandaloneEvent.ZoomElement),
    pageView: () => gtm.track({ name: StandaloneEvent.PageView }),
  });
  /* eslint-enable prettier/prettier */

  export const session = gtm.session.bind(gtm);
  export const instance = gtm;
}

function createStandaloneEventTrack<Name extends Types.StandaloneEventName>(name: Name) {
  return async function (properties: Types.StandaloneEventPayload<Name>, config?: TrackConfig) {
    return gtm.track({ name, properties }, config);
  };
}

if (typeof window !== 'undefined') {
  (window as any).Gtm = Gtm;
}
